<template>
  <div class="bj-col bj-col-24">
    <!--  信息描述  -->
    <div class="main-title">Cargo Solutions Group Pty Ltd</div>
    <div class="middle-title">62 Goodall Close, Dandenong South VlC 3175</div>
    <el-descriptions column="2" :colon="false" labelClassName="label-class-name" contentClassName="content-class-name">
      <el-descriptions-item :label="this.$t('InternalSalesOrderDetails.CustomerName')">{{ rowData.customerName }}</el-descriptions-item>
      <el-descriptions-item :label="this.$t('InternalSalesOrderDetails.PaymentStatus')" :contentClassName="[targetGroupClass, 'content-class-name']" :labelStyle="{marginLeft: '30%'}">{{ paymentStatusShow }}</el-descriptions-item>
      <el-descriptions-item :label="this.$t('InternalSalesOrderDetails.PaymentId')">{{ rowData.paymentID }}</el-descriptions-item>
      <el-descriptions-item :label="this.$t('InternalSalesOrderDetails.InvoiceNo')" :labelStyle="{marginLeft: '30%'}">{{ rowData.invoiceNo }}</el-descriptions-item>
      <el-descriptions-item :label="this.$t('InternalSalesOrderDetails.OrderDate')">{{ rowData.orderDate }}</el-descriptions-item>
      <el-descriptions-item :label="this.$t('InternalSalesOrderDetails.InvoiceWeek')" :labelStyle="{marginLeft: '30%'}">{{ rowData.invoiceWeek }}</el-descriptions-item>
    </el-descriptions>

    <!--  表格  -->
    <table class="table-custom">
      <thead>
      <tr>
        <th>{{ this.$t('InternalSalesOrderDetails.PaymentTableNO') }}</th>
        <th>{{ this.$t('InternalSalesOrderDetails.PaymentTableItem') }}</th>
        <th>{{ this.$t('InternalSalesOrderDetails.PaymentTableQty') }}</th>
        <th>{{ this.$t('InternalSalesOrderDetails.PaymentTablePrice') }}</th>
        <th>{{ this.$t('InternalSalesOrderDetails.PaymentTableTotal') }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in rowData.transactionItems" :key="item.no">
        <td>{{ index + 1 }}</td>
        <td>{{ item.itemName }}</td>
        <td>{{ item.qty }}</td>
        <td>{{ item.unitPrice }}</td>
        <td>{{ item.total }}</td>
      </tr>
      <tr>
        <td colspan="3"></td>
        <td>{{ this.$t('InternalSalesOrderDetails.PaymentTableSubTotal') }}</td>
        <td>{{ rowData.subTotal }}</td>
      </tr>
      <tr>
        <td colspan="3"></td>
        <td>{{ this.$t('InternalSalesOrderDetails.PaymentTableGST') }}</td>
        <td>{{ rowData.gst }}</td>
      </tr>
      <tr>
        <td colspan="3"></td>
        <td>{{ this.$t('InternalSalesOrderDetails.PaymentTableSubTotalGST') }}</td>
        <td>{{ rowData.total }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    rowData: {
      type: Object,
      default: () => ({
        companyName: '',
        address: '',
        customerName: '',
        paymentStatus: '',
        paymentID: '',
        invoiceNo: '',
        orderDate: '',
        invoiceWeek: '',
        transactionItems: []
      })
    }
  },
  data() {
    return {
      classGroup: [
        {class: 'complete-class', includeArr: ['PAID']},
        {class: 'un-complete-class', includeArr: ['UNPAID']},
        {class: '', includeArr: ['PREVIEW']},
      ]
    };
  },
  computed: {
    targetGroupClass() { // 不同支付状态转对应类名
      return this.findTargetClass(this.rowData.paymentStatus);
    },
    paymentStatusShow() { // 支付状态展示
      return this.toTitleCase(this.rowData.paymentStatus);
    }
  },
  methods: {
    // value对应类名样式
    findTargetClass(value) {
      const TARGET = this.classGroup.find(item => {
        return item.includeArr.includes(value);
      });
      return TARGET?.class || '';
    },
    // 转开头大写英文
    toTitleCase(str) {
      if (!str) {
        return;
      }
      return str
        .trim()
        .split(/\s+/) // 按任意空格分割为单词数组
        .map(word =>
          word.charAt(0).toUpperCase() + // 首字母大写
          word.slice(1).toLowerCase() // 剩余字母小写
        )
        .join(' '); // 重新组合成字符串
    }
  }
};
</script>

<style lang="scss" scoped>
.main-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
.middle-title {
  text-align: center;
  margin: 12px 0 20px 0;
}
.table-custom {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

/* 清除所有单元格默认边框 */
.table-custom th,
.table-custom td {
  font-size: 12px;
  border: none;
  padding: 6px 12px 6px 12px;
  text-align: left;
}

.table-custom thead th {
  border-top: 3px solid #ddd;
  border-bottom: 3px solid #ddd;
}

.table-custom tbody tr:not(:last-child) td {
  border-bottom: none;
}

.table-custom tbody tr:nth-last-child(4) td {
  border-bottom: 1px solid #eee;
}

.table-custom tbody tr:last-child td {
  border-bottom: 3px solid #eee;
}
::v-deep {
  .complete-class {
    color: rgba(22, 122, 32);
  }
  .un-complete-class {
    color: rgba(221, 25, 50);
  }
  .label-class-name, .content-class-name {
    font-size: 12px;
    font-weight: bold;
  }
  .label-class-name {
    width: 100px;
  }
  .content-class-name {
    flex: 1;
  }
  .ml14 {
    margin-left: 14px;
  }
  .content-class-name{
    word-break: break-all;
  }
}
</style>
